import React from 'react';
import DataGrid, {
    Column,
    Scrolling,
    Selection,
    FilterRow,
    Grouping
} from 'devextreme-react/data-grid';
import DropDownBox from 'devextreme-react/drop-down-box';
import { cellRender } from '../../utils/common';
const dropDownOptions = { width: 880, height: 300 };
class ItemDDBComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentValue: props.data.value
        };
        this.dropDownBoxRef = React.createRef();
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.contentRender = this.contentRender.bind(this);
        this.onRowPrepared = this.onRowPrepared.bind(this);
    }   

    onRowPrepared = (e) => {
        if (e.rowType == 'group') {

            //if (!e.data.active) 
                e.rowElement.classList.add('inverted-row');
            
        }
    }

    contentRender() {
        
        // console.log(this.props.data.column.lookup.dataSource);

        // const dataSource = this.props.data.column.lookup.dataSource.map(item => {

        //     if(item.typeId == 1 && !item.type.includes('2'))
        //         item.type = 2 + ' ' + item.type;
        //     if(item.typeId == 2 && !item.type.includes('3'))
        //         item.type = 3 + ' ' + item.type;
        //     if(item.typeId == 3 && !item.type.includes('1'))
        //         item.type = 1 + ' ' + item.type;
        //     if(item.typeId == 4 && !item.type.includes('6'))
        //         item.type = 6 + ' ' + item.type;
        //     if(item.typeId == 5 && !item.type.includes('5'))
        //         item.type = 5 + ' ' + item.type;
        //     if(item.typeId == 6 && !item.type.includes('4'))
        //         item.type = 4 + ' ' + item.type;
                
            
        //     return item;

        // });

        return (
            <DataGrid
                dataSource={this.props.data.column.lookup.dataSource}
                id="idGrid"
                keyExpr="id"                
                height={250}               
                selectedRowKeys={[this.state.currentValue]}
                hoverStateEnabled={true}
                onSelectionChanged={this.onSelectionChanged}
                focusedRowEnabled={true}
                defaultFocusedRowKey={this.state.currentValue}
                rowAlternationEnabled={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onRowPrepared={this.onRowPrepared}
            >
                <Grouping autoExpandAll={false} expandMode='rowClick' />
                <FilterRow visible={true} />
                <Column dataField="type" caption="Tipo" groupIndex={0}></Column>
                <Column dataField="id" caption="id" width={80} visible={false}></Column>
                <Column dataField="code" caption="Codigo" width={80}></Column>
                <Column dataField="name" caption="Nombre"></Column>             
                {/* <Column dataField="cost" caption="Costo" cellRender={cellRender()} width={80}></Column> */}
                <Column dataField="price" caption="Precio Vta" cellRender={cellRender()} width={80}></Column>
                <Column dataField="stock" caption="Cant" width={80}></Column>                
                <Scrolling mode="virtual" />
                <Selection mode="single" />
            </DataGrid>
        );
    }

    onSelectionChanged(e) {

        this.setState({ currentValue: e.selectedRowKeys[0] });
        this.props.data.setValue(this.state.currentValue);
        if (e.selectedRowKeys.length > 0) {   
            this.dropDownBoxRef.current.instance.close();     
            this.props.data.component.editCell(this.props.data.rowIndex, 'quantity');       
        }

    }

    

    render() {
        return (
            <DropDownBox
                ref={this.dropDownBoxRef}
                key="id"
                dropDownOptions={dropDownOptions}
                dataSource={this.props.data.column.lookup.dataSource}
                value={this.state.currentValue}
                displayExpr={item => item ? `${item.code} - ${item.name}` : ''}
                valueExpr="id"                
                contentRender={this.contentRender}>
            </DropDownBox>
        );
    }
}

export default ItemDDBComponent;
